<template>
    <v-container fluid fill-height>
        <v-layout style="display: block;">
            <applicants-index/>
        </v-layout>
    </v-container>
</template>
<script>
    import ApplicantsIndex from "../../../../components/admin/Students/Applicants/ApplicantsIndex";
    export default  {
        components: {
            ApplicantsIndex,
        }
    }
</script>